'use client';

import { useEffect } from 'react';
import { create } from 'zustand';

interface LauncherSpot {
  right: number;
  //* 하단 크롬(--bottom-inset) 위 간격
  bottom: number;
  launcherSize: number;
}

export interface CsChatLayoutValue {
  desktop: LauncherSpot;
  mobile: LauncherSpot;
}

const WIDGET_DEFAULT_SPOT = { right: 24, bottom: 24, launcherSize: 84 };

export const DEFAULT_CS_CHAT_LAYOUT: CsChatLayoutValue = {
  desktop: WIDGET_DEFAULT_SPOT,
  mobile: WIDGET_DEFAULT_SPOT,
};

//* 웰로·고기부 마이페이지 시안
export const MY_PAGE_CS_CHAT_LAYOUT: CsChatLayoutValue = {
  desktop: { right: 57, bottom: 54, launcherSize: 80 },
  mobile: { right: 24, bottom: 14, launcherSize: 80 },
};

export const useCsChatLayoutStore = create<{
  layout: CsChatLayoutValue | null;
}>(() => ({ layout: null }));

export const CsChatLayout = ({ layout }: { layout: CsChatLayoutValue }) => {
  useEffect(() => {
    useCsChatLayoutStore.setState({ layout });

    return () => {
      useCsChatLayoutStore.setState({ layout: null });
    };
  }, [layout]);

  return null;
};
